<template>
    <div
        class="rounded-6 rounded-bl-none rounded-br-none bg-white text-primary-80 relative mb-16"
        :class="[
            customCss,
        ]"
    >
        <div class="flex items-center justify-between flex-nowrap">
            <div class="space-y-12 grow">
                <div class="flex items-center flex-1 gap-8">
                    <div class="block fill-current flex-none trans-ease">
                        <svg-icon class="text-secondary" :type="icon" />
                    </div>
                    <slot name="title" />
                    <h1
                        class="text-black text-opacity-85 text-body font-semibold first-letter:uppercase"
                        v-if="!$slots.title"
                    >
                        {{ title }}
                    </h1>
                </div>
                <p v-if="description" class="text-black first-letter:capitalize" v-html="description"></p>
            </div>

            <slot />

            <toggle
                v-if="withToggle"
                v-model="toggleValue"
                @change="$emit('toggle', toggleValue)"
                :before="true"
                class="self-start"
            >
                <span><slot name="toggle-text" /></span>
            </toggle>
        </div>
    </div>
</template>

<script>
import SvgIcon from "../ui/SvgIcon";
import Toggle from "../forms/Toggle.vue";

export default {
    components: {
        Toggle,
        SvgIcon,
    },
    props: {
        title: String,
        description: String,
        icon: {type: String, default: 'bar-chart'},
        customCss: String,
        noBorders: {type: Boolean, default: false},
        noPadding: {type: Boolean, default: false},
        withToggle: {type: Boolean, default: false},
    },
    data() {
        return {
            toggleValue: false,
        }
    },
}
</script>

<style scoped>
.bounce {
    animation: bounce 1s cubic-bezier(.65,-0.15,.35,1.15) alternate infinite;
}
@keyframes bounce {
    0% {
        left: -100%;
    }
    100% {
        left: 100%;
    }
}
</style>
